import React from "react";
import {
  Routes, // instead of "Switch"
  Route,
} from "react-router-dom";

import Home from "../pages/home";
import About from "../pages/about";
import Services from "../pages/services";
import CourseDetails from "../pages/course/course-single";
import Faq from "../pages/faq";
import Contact from "../pages/contact";
import Error from "../pages/404";
import Course from "../pages/course";
import NewsEvent from "../pages/news-event";
import KidsCourse from "../pages/kids-course";
import InstructorRegister from "../pages/instructor-register";
import CourseRegister from "../pages/course-register";
import InternRegister from "../pages/internship-register";
import SiwesRegister from "../pages/siwes-register";
import Portpolio from "../pages/portfolio";
import BookCall from "../pages/book-call";
import Consultation from "../pages/consultation";
import ProjectsPage from "../pages/about/projects";

// Import consultation service pages
import SoftwareDevelopment from "../pages/consultation/services/SoftwareDevelopment";
import SecurityConsultation from "../pages/consultation/services/SecurityConsultation";
import SoftwareMaintenance from "../pages/consultation/services/SoftwareMaintenance";
import DigitalMarketing from "../pages/consultation/services/DigitalMarketing";
import DigitalTransformation from "../pages/consultation/services/DigitalTransformation";
import TechnologyConsultation from "../pages/consultation/services/TechnologyConsultation";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/" exact element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about-us" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/courses" exact element={<Course />} />
      <Route path="/kids/courses" exact element={<KidsCourse />} />
      <Route path="/course/details/:id" element={<CourseDetails />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/portfolio" element={<Portpolio />} />
      <Route path="/contact-us" element={<Contact />} />
      <Route path="/news" element={<NewsEvent />} />
      <Route path="/instructor/register" element={<InstructorRegister />} />
      <Route path="/course/register/:id/:type" element={<CourseRegister />} />
      <Route path="/course/register/:id" element={<CourseRegister />} />
      <Route path="/intern/register" element={<InternRegister />} />
      <Route path="/siwes/register" element={<SiwesRegister />} />
      <Route path="/book-call" element={<BookCall />} />
      <Route path="/consultation" element={<Consultation />} />
      
      {/* Consultation Service Routes */}
      <Route path="/consultation/software-development" element={<SoftwareDevelopment />} />
      <Route path="/consultation/security" element={<SecurityConsultation />} />
      <Route path="/consultation/software-maintenance" element={<SoftwareMaintenance />} />
      <Route path="/consultation/digital-marketing" element={<DigitalMarketing />} />
      <Route path="/consultation/digital-transformation" element={<DigitalTransformation />} />
      <Route path="/consultation/technology" element={<TechnologyConsultation />} />
      
      <Route path="/about/projects" element={<ProjectsPage />} />
      
      <Route element={<Error />} />
    </Routes>
  );
};

export default App;
